import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';

interface TabInfo {
    label: string;
    active: boolean;
    index: number;
}

@Component({
    selector: 'tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
})
export class TabComponent implements OnInit {
    @Input() tabs: any[];
    @Input() setDefaultIndex?: number;
    selectedTab: number;
    @Output('tabChange') change: EventEmitter<number> = new EventEmitter<number>();
    constructor() {}

    ngOnInit() {
        this.selectedTab = 0;
        this.validateSetDefaultIndex();
    }

    validateSetDefaultIndex() {
        if (this.setDefaultIndex) {
            if (this.setDefaultIndex < this.tabs.length) {
                this.selectedTab = this.setDefaultIndex;
            }
        }
    }
    tabActivated(tab: MatTabChangeEvent) {
        this.selectedTab = tab.index;
        this.change.emit(this.selectedTab);
    }
}
